class Header {
  constructor() {
    this.headerLower = document.querySelector('.js-header-lower');
    if (!this.headerLower) return;

    this.menuButton = this.headerLower.querySelector('.js-header-lower-menu-button');
    this.overlay = this.headerLower.querySelector('.js-header-lower-overlay');
    this.panel = this.headerLower.querySelector('.js-header-lower-menu-panel');
    this.closeButton = this.headerLower.querySelector('.js-header-lower-menu-close');

    this.isPanelOpen = false;
    this.init();
  }

  init() {
    if (this.menuButton) {
      this.menuButton.addEventListener('click', () => {
        this.toggle();
      });
    }

    if (this.overlay) {
      this.overlay.addEventListener('click', () => {
        this.toggle();
      });
    }

    if (this.closeButton) {
      this.closeButton.addEventListener('click', () => {
        this.toggle();
      });
    }
  }

  open() {
    if (this.isPanelOpen) return;
    this.isPanelOpen = true;
    this.overlay.classList.add('menu-overlay--visible');
    this.panel.classList.add('menu-panel--open');
    document.body.style.overflow = 'hidden';
  }
  close() {
    if (!this.isPanelOpen) return;
    this.isPanelOpen = false;
    this.overlay.classList.remove('menu-overlay--visible');
    this.panel.classList.remove('menu-panel--open');
    document.body.style.overflow = '';
  }
  toggle() {
    if (this.isPanelOpen) {
      this.close();
    } else {
      this.open();
    }
  }
}

export default Header;
